export default {
  'STOCK': 'Securities',
  'FUTURES': 'Futures',
  'FOREX': 'Foreign Exchange',
  'IB': 'EddidPro',
  'FUND': 'Fund',
  'mt5': '(MT5)',
  'mf': '(Eddid FX Pro)',
  'ACCOUNT': 'Account',
  'MF': 'FX Pro',
  'PM': 'Spot Gold',
  'fundCash': 'Fund',
  'stockOptionsCash': 'Hong Kong Stock Option Account (Cash)',
  'securitiesCash': 'Hong Kong and Global Securities Accounts (Cash)',
  'securitiesMargin': 'Hong Kong and Global Securities Accounts (Margin)',
  'securitiesDayTradeMargin': 'Hong Kong Securities Day Trade Account (Margin)',
  'futuresMargin': 'Hong Kong and Global Futures Account (Margin)',
  'futuresDayTradeMargin': 'Hong Kong Futures Day Trade Account (Margin)',
  'interactiveBrokerIntegratedMargin': 'InteractiveBroker Comprehensive Account (Margin)',
  'please_select': 'Please select',
  'please_select_currency': 'Please select the currency',
  'submit': 'Submit',
  'please_input': 'Please enter',
  'contiune': 'Continue',
  'ok': 'Confirm',
  'edit': 'Edit',
  'cancel': 'Cancel',
  'yes': 'Yes',
  'no': 'No',
  'resign': 'Re-sign',
  'cancelLogout': 'Logout canceled',
  'noCancel': 'The order cannot be canceled',
  'codeFail': 'Verification code is incorrect',
  'changeSuccess': 'Modified successfully.',
  'changeFail': 'Modification failed.',
  'inputNewPassword': 'Please enter a new password',
  'inputNewPasswordAgain': 'Please enter a new password again',
  'notIdentical': 'The two passwords do not match',
  'uploadFail': 'Network error. Uploading failed.',
  'imageRepeat': 'No duplicate uploads!',
  'fail': 'Failed',
  'loadingFailTip': 'Failed to load',
  'exhangeTo': 'Exchange to',
  'usd': 'USD',
  'hkd': 'HKD',
  'cny': 'CNY',
  'cencel_dialog': {
    'tip': {
      'withdrawal': 'Are you sure you would like to cancel the withdrawal?',
      'transfer': 'Are you sure you would like to cancel the transfer?'
    },
    'cancel': {
      'withdrawal': 'You have successfully cancelled the withdrawal. ',
      'transfer': 'You have successfully cancelled the transfer. '
    },
    'check_info': 'Confirm information',
    'reminder': 'Please confirm and submit the information.'
  },
  'preview_dialog': {
    'tip': {
      'deposit': 'Please verify your deposit receipt and avoid uploading it multiple times. If you have any questions, please contact us',
      'withdrawal': 'If you make transactions during the withdrawal application period, it may result in withdrawal failure. If there are any issues, please contact us',
      'transfer': 'If you make transactions during the withdrawal application period, it may result in withdrawal failure. If there are any issues, please contact us',
      'attention': 'Attention'
    },
    'tip1': `<div style="margin-bottom: 4px">1. The Company will charge a bank transfer commission of HKD 350 for each transfer.</div>'    '<div style="margin-bottom: 4px">2. The bank may charge administrative costs. Please inquire with the recipient bank.</div>'    '3. If you remit money to Chinese mainland, a bank of Chinese mainland may reject the remittance. In the case of refund, the commission charged will not be refunded.`,
    'withdrawalTip': `<div style="margin-bottom: 4px">1. As the gift stocks converted and sold by you do not conform to the trading task required in this activity, Eddid Securities and Futures will charge the first year’s account management fee of USD 27 in the next withdrawal according to the activity rules.</div>'      <div style="margin-bottom: 4px">2. If you are trading during the withdrawal application, it may result in withdrawal failure. If you have any questions, please contact us.`,
    'withdrawalfinanceTip': `<div style="margin-bottom: 4px">1. You have submitted a "One-Hand Financing" IPO subscription application, and your total securities account assets fall below HKD 5,000.00 after the withdrawal. According to company policy, an additional handling fee of {} or its equivalent in other currencies will be charged for this withdrawal. (Calculated as an additional handling fee of HKD 500.00 per "One-Hand Financing" subscription application)</div>2. If you are trading during the withdrawal application period, it may result in a failed withdrawal. If you have any questions, please contact us.`,
'withdrawalallTip': `<div style="margin-bottom: 4px">1. As you have redeemed and sold the gifted stocks without completing the required trading tasks for this promotion, according to the campaign rules, Eddid Securities and Futures will charge a first-year account management fee of USD 27 for this withdrawal.</div><div style="margin-bottom: 4px">2. You have submitted a "One-Hand Financing" IPO subscription application, and your total securities account assets fall below HKD 5,000.00 after the withdrawal. According to company policy, an additional handling fee of {} or its equivalent in other currencies will be charged for this withdrawal. (Calculated as an additional handling fee of HKD 500.00 per "One-Hand Financing" subscription application)</div><div style="margin-bottom: 4px">3. If you are trading during the withdrawal application period, it may result in a failed withdrawal. If you have any questions, please contact us.</div>`,
    'overseaTip': `<div style="margin-bottom: 4px">1. As you have redeemed and sold the gifted stocks without completing the required trading tasks for this promotion, according to the campaign rules, Eddid Securities and Futures will charge a first-year account management fee of USD 27 for this withdrawal.</div><div style="margin-bottom: 4px">2. If you are trading during the withdrawal application period, it may result in a failed withdrawal. If you have any questions, please contact us.</div><div style="margin-bottom: 4px">3. The company charges a bank transfer handling fee of HKD 350 per transaction.</div><div style="margin-bottom: 4px">4. Banks may charge administrative fees. Please consult the receiving bank for details.</div>5. If remitting funds to Chinese Mainland, there may be cases where Mainland banks reject and return the funds. In the event of a refund, any handling fees already charged will not be refunded.`,
    'overseafinanceTip': `<div style="margin-bottom: 4px">1. You have submitted a "One-Hand Financing" IPO subscription application, and your total securities account assets fall below HKD 5,000.00 after the withdrawal. According to company policy, an additional handling fee of {} or its equivalent in other currencies will be charged for this withdrawal. (Calculated as an additional handling fee of HKD 500.00 per "One-Hand Financing" subscription application)</div><div style="margin-bottom: 4px">2. If you are trading during the withdrawal application period, it may result in a failed withdrawal. If you have any questions, please contact us.</div><div style="margin-bottom: 4px">3. The company charges a bank transfer handling fee of HKD 350 per transaction.</div><div style="margin-bottom: 4px">4. Banks may charge administrative fees. Please consult the receiving bank for details.</div>5. If remitting funds to Chinese Mainland, there may be cases where Mainland banks reject and return the funds. In the event of a refund, any handling fees already charged will not be refunded.`,
    'overseaallTip': `<div style="margin-bottom: 4px">1. As you have redeemed and sold the gifted stocks without completing the required trading tasks for this promotion, according to the campaign rules, Eddid Securities and Futures will charge a first-year account management fee of USD 27 for this withdrawal.</div><div style="margin-bottom: 4px">2. You have submitted a "One-Hand Financing" IPO subscription application, and your total securities account assets fall below HKD 5,000.00 after the withdrawal. According to company policy, an additional handling fee of {} or its equivalent in other currencies will be charged for this withdrawal. (Calculated as an additional handling fee of HKD 500.00 per "One-Hand Financing" subscription application)</div><div style="margin-bottom: 4px">3. If you are trading during the withdrawal application period, it may result in a failed withdrawal. If you have any questions, please contact us.</div><div style="margin-bottom: 4px">4. The company charges a bank transfer handling fee of HKD 350 per transaction.</div><div style="margin-bottom: 4px">5. Banks may charge administrative fees. Please consult the receiving bank for details.</div>6. If remitting funds to Chinese Mainland, there may be cases where Mainland banks reject and return the funds. In the event of a refund, any handling fees already charged will not be refunded.`,
    'transferfinanceTip': `<div style="margin-bottom: 4px">1. You have submitted a "One-Hand Financing" IPO subscription application, and your total securities account assets fall below HKD 5,000.00 after the transfer. According to company policy, an additional handling fee of {} or its equivalent in other currencies will be charged for this transfer. (Calculated as an additional handling fee of HKD 500.00 per "One-Hand Financing" subscription application)</div>
    2. If you are trading during the transfer application period, it may result in a failed transfer. If you have any questions, please contact us.`,
    'transferTip': '<div style="margin-bottom: 4px">If you are trading during the transfer application, it may ressult in transfer failure. If you have any questions, please contact us.</div>',
    'check_info': 'Check Information',
    'reminder': 'Please confirm and submit the information',
    'outAccount': 'Debit Account Number',
    'inAccount': 'Beneficiary Account Number',
    'outAmount': 'Amount Transferred',
    'account_number': 'Account Number',
    'bank_card_number': 'Bank Card Number',
    'bank_card_name': 'Bank Name',
    'withdrawal_amount': 'Withdrawal Amount',
    'serviceCharge': 'Service Fee',
    'accountFee': 'Account Management Fee',
    'actualAmount': 'Actual Amount Withdrawn',
    'withdrawal_name': 'English Name/Chinese Name',
    'withdrawal_bank_name': 'Bank Name',
    'withdrawal_bank_card': 'Bank Card Number',
    'withdrawal_swift_no': 'SWIFT Code',
    'otherBankName': 'Other Bank Name',
    'otherBankCard': 'Other Bank Account Number',
    'financeFee': 'One-Board Lot Financing Fee',
    'actualtransferAmount': 'Actual Transfer Amount',
    'account_info': 'Account Number',
    'bank_info': 'Bank Card Number',
    'eddid_bank': 'Eddid Bank Card Number',
    'depositAmount': 'Deposit Amount',
    'number': 'Client Account Number',
    'customer': 'Client Name',
    'amount': 'Deposit Amount',
    'tradeAccount': 'Trading Account Number',
    'exchangeCurrency': 'Exchange Currency',
    'exchangeRate': 'Exchange Rate',
    'swapAmount': 'Foreign Exchange Amount'
  },
  'accountOpen': 'Application for Sub-Accounts',
  'accountClose': 'Application for Cancellation',
  'three_list': {
    'bankName': 'Bank Name',
    'currency': 'Bank Currency',
    'createdTime': 'Submission Time',
    'bankNum': 'Bank Account Number',
    'transfer': 'Transfer',
    'withdrawal': 'Withdraw',
    'deposit': 'Deposit',
    'cenceledBtn': 'Cancel',
    'fromAccount': 'Debit Account Number',
    'toAccount': 'Beneficiary Account Number',
    'outAmount': 'Amount Transferred',
    'accountNo': 'Account Number',
    'bankCard': 'Bank Card Number',
    'withdrawalAmout': 'Amount Withdrawn',
    'depositAmout': 'Amount Deposited',
    'remark': 'Remarks',
    'amout': 'Amount',
    'fullName': 'Client Name',
    'applicationAmount': 'Amount Applied for',
    'completed': 'Completed',
    'processing': 'Submitted',
    'failure': 'Failed',
    'submitted': 'Submitted',
    'withdrawalcompleted': 'Processed',
    'checking': 'Submitted',
    'verified': 'Submitted',
    'latest_records': 'Latest Record',
    'view_more': 'View More Information >',
    'order_No': 'Order Number',
    'enName': 'English Name/Chinese Name',
    'swiftNo': 'SWIFT Code',
    'updatedTime': 'Update Time',
    'exchangeRate': 'Exchange Rate',
    'toCurrency': 'Currency Converted into',
    'swapAmount': 'Foreign Exchange Amount',
    'applyService': 'Application Service',
    'fee': 'Expense Detail',
    'businessId': 'Remarks',
    'realAmount': 'Amount Received',
    'exchangeAmount': 'Amount Credited after Conversion',
    'fundBankType': 'Order Processing',
    'tradeAccountType': 'Trading Account',
    'depositWay': 'Deposit Method',
    'withdrawoutWay': 'Withdrawal Method',
    'accountName': 'Account Name',
    'applyTime': 'Application Time',
    'realExchangeRate': 'Actual Exchange Rate',
    'exchangeAmountapply': 'Amount Applied For',
    'lockWay': 'Freeze Direction',
    'exchangeRealAmount': 'Actual Exchange Amount'
  },
  'upload': {
    'uploadFail': 'Network is unstable. Failure to upload images. ',
    'limitNumber': 'Only {0}pictures can be uploaded.',
    'limitSize': 'The image size exceeds {0}MB, upload failed.'
  },
  'eddidTips': 'If your information is different from the information submitted at the time of account opening, please call +852 2655 0338 / 400 120 0068  (Chinese Mainland Toll-Free Line) or send an email to cs@eddidsec.com to contact the customer service personnel. Thank you.',
  'applyText': 'Apply',
  'nodata': 'No Data',
  'uploadImg': 'Please upload pictures',
  'yztransfer': 'Bank-Securities Transfer',
  'BANK_SECURITIES_ADD': 'Bind Bank-Securities Transfer',
  'BANK_SECURITIES_UNBIND': 'Unbind Bank-Securities Transfer',
  'yzAccount': 'Bank-Securities Transfer Account',
  'commonAccount': 'Ordinary Account',
  'iknow': 'I Understand',
  'knowIt': 'I Understand',
  'gotIt': 'I Understand',
  'statementArr': [
    {
      'text': '《Personal Data Collection Statement》',
      'link': 'https://download.eddidapp.com/pdf/EN/personalStatement.pdf'
    },
    {
      'text': '《Statement on Common Reporting Standards》',
      'link': 'https://download.eddidapp.com/pdf/EN/statementCommonReportingStandards.pdf'
    },
    {
      'text': '《Customers Statement》',
      'link': 'https://download.eddidapp.com/pdf/EN/customerStatement.pdf'
    },
    {
      'text': '《Privacy Policy Statement》',
      'link': 'https://download.eddidapp.com/pdf/EN/privacy-policy-statement.pdf'
    },
    {
      'text': '《Risk Disclosure Statement》',
      'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/EN/Risk-Disclosure-Statement.pdf'
    },
    {
      'text': '《Terms and Conditions of Business》',
      'link': 'https://download.eddidapp.com/pdf/EN/Business-Terms-and-Conditions.pdf'
    },
    {
      'text': '《Provisions related to Customer Application for Digital Certificate》',
      'link': 'https://download.eddidapp.com/pdf/SC/customersTerms.pdf'
    }
  ],
  'otherText': 'Other',
  'spInfo': 'This operation is not supported for Sharp Point trading account',
  'riskTolerance': 'Risk Bearing Capacity',
  'high': 'High',
  'medium': 'Medium',
  'low': 'Low',
  'invest': 'Purpose of Investment',
  'speculation': 'Speculation',
  'hedge': 'Hedging',
  'assetAppreciation': 'Assets Enhancement',
  'interestIncome': 'Interest/Dividend Income',
  'targetError': 'Please select the purpose of investment',
  'futuredErrorInfo': 'Futures products account cannot be opened for the sole purpose of interest/dividend income',
  'riskError': 'If the risk bearing capacity is medium/low, it is not appropriate to trade structured products and derivative products.',
  'dormant': 'Inactive',
  'dormantTip': 'You can reactivate your account via mobile application. Should you have any enquiries, please contact our Customer Service Team at +852 2655 0338 / 400 120 0068  (Chinese Mainland Toll-Free Line) or email us at cs@eddidsec.com.',
  'dormantDetailTip': 'Your trading account is currently inactive, the functions for fund and stock withdrawal are restricted. You can reactivate your account via mobile application. Should you have any enquiries, pleasecontact our Customer Service Team at +852 2655 0338 / 400 120 0068  (Chinese Mainland Toll-Free Line) or email us at cs@eddidsec.com.',
  'reactivate': 'Reactivate',
  'back': 'Back',
  'sureBtn': 'Confirm',
  blockedTip: 'To comply with the latest regulatory requirements, fund deposit services are currently suspended in your region. For enquiries, please contact us at +852 2655 0338 / 400 120 0068  (Chinese Mainland Toll-Free Line).'
}
